<template>
  <div
    id="app"
    :class="[
        'u-flex u-flex-col u-full-height u-overflow-hidden',
        isShowreel ? 'is-homepage' : '',
        isVideo ? 'is-video' : ''
      ]">
    <main id="main" class="u-bg-white">
      <div class="o-container">
        <Header />
        <div class="o-page">
          <transition :name="transition">
            <router-view/>
          </transition>
        </div>
      </div>
    </main>
    <transition name="fade">
      <router-view name="modal" />
    </transition>
    <Footer />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  data() {
    return {
      transition: 'next',
      isShowreel: true,
      isVideo: false,
    };
  },
  components: { Header, Footer },
  computed: mapState({
    pageOrder: state => state.publicSlugs.concat('about', 'private'),
    title: state => state.hasLoaded ? state.seo.groups.showreel.title : state.defaultMetaTitle,
    description: state => state.hasLoaded ? state.seo.groups.showreel.description : state.defaultMetaDescription,
  }),
  methods: {
    isHomepage() {
      return this.$route.fullPath === '/';
    },
    isVideoPage(route) {
      return route === 'video';
    },
    fixScrollBehavior () {
      document.getElementById('main').scrollTop = 0;
    }
  },
  watch: {
    $route(to, from) {
      setTimeout(this.fixScrollBehavior, 100);
      this.isVideo = this.isVideoPage(this.$route.name);
      this.isShowreel = this.isHomepage();
      if (to.name === 'video' || from.name === 'video') {
        this.transition = 'fade';
      } else {
        const current = this.pageOrder.findIndex(page => page === from.name);
        const next = this.pageOrder.findIndex(page => page === to.name);
        this.transition = current > next ? 'prev' : 'next';
      }
    },
  },
  mounted() {
    this.isShowreel = this.isHomepage();
    this.isVideo = this.isVideoPage(this.$route.name);
  },
};
</script>